// HirePlus finalize ******************************************************************************
// pathname: /v1/job-operation/{jobSlug}/hire-plus-finalize
// ************************************************************************************************
import { useSwrMutationApi } from 'src/hooks/useSwrApi';
import { bjToast } from '@components/common';
import { useTranslation } from 'next-i18next';

type HirePlusFinalizePayload = ApiSchema<'HirePlusFinalizeRequest'>;

/**
 * @description SWR mutation: POST to record the hired salary for a HirePlus (fhire-fix) job
 * and charge the account 1:1 in credits. Admin-only via impersonation; the backend voter is
 * the source of truth — this hook is just the network call.
 */
export const useSwrHirePlusFinalize = (jobSlug: string, locale = 'ro') => {
  const { t } = useTranslation('common');

  const {
    data, error, isMutating, reset, trigger,
  } = useSwrMutationApi<object, HirePlusFinalizePayload>({
    url: `/v1/job-operation/${jobSlug}/hire-plus-finalize`,
    locale,
    fetcherConfig: {
      method: 'POST',
      stringifyPayload: true,
    },
    apiOptions: {
      onSuccess: () => {
        bjToast.success(t('global.label.success'));
      },
      onError: (newError) => {
        if (newError.errors[0]?.message) {
          bjToast.error(newError.errors[0].message);
        }
      },
    },
  });

  return {
    data,
    error,
    isMutating,
    reset,
    trigger,
  };
};
